import {Coordinate} from "ol/coordinate";
import {ContainerEnum, GetListParams, GetListResponse} from "shared/types";

export type TCreatePlanAPIData = {
  tracking_numbers: string[];
  plan_no: string;
  bunny_color: ContainerEnum;
  plan_date: string;
};

export type TUpdatePlanAPIData = {
  tracking_number_list: string[];
  dest_plan_id: number;
  plan_date: string;
  plan_no: string;
};

export interface IZipcodeResponse extends GetListResponse<TZipcodeItem> {
  "bbox": {
    "min_x": 126.81326301574705,
    "max_x": 126.84673698425293,
    "min_y": 37.523725115542035,
    "max_y": 37.61624615171968
  },
  "bbox_area_sq_km": 25.17,
}

export type TZipcodeItem = {
  zipcode: string;
  "zipcode_geometry": {
    "type": "Polygon",
    "coordinates": [Coordinate[]];
  },
};

export type TSectorItem = {
  id: number;
  code: string;
  name: string;
  name_category: string;
  area: string;
  description: string;
  min_x: string;
  min_y: string;
  max_x: string;
  max_y: string;
}

export type TCoordinatesItem = {
  id: number;
  "code": string,
  "name": string,
  "description": string,
  "preference": boolean,
  "allowed": boolean,
  "metadata": {
    "zipcodes": [string],
  },
  "sector_geometry": {
    "type": "Polygon",
    "coordinates": [Coordinate[]],
  },
  has_zipcode: boolean;
  unit_storages_dict: [
    {
      address__lat: number;
      address__lng: number;
      id: number;
      name: string
    }
  ];
};

export const MapSearchParamKey = {
  mapCenterLat: "map_center_lat", mapCenterLng: "map_center_lng", mapZoom: "map_zoom",
}
export const PlanSearchParamKey = {
  chuteId: "chute_id",
  clusterId: "cluster_id",
  clusterIdStartswith: "cluster_id__startswith",
  clusterIdStartswithInCsv: "cluster_id_startswith_in_csv",
  chuteIdIn: "chute_id__in",
  idGt: "id__gt",
  ordering: "ordering",
  planDate: "plan_date",
  planNo: "plan_no",
  planId: "plan_id",
  planNoIn: "plan_no__in",
  sectorCode: "sector_code",
  sectorCodeIn: "sector_code__in",
  synced: "synced",
} as const;

export interface IGetPlanLongAPIParam extends GetListParams {
  chute_id?: number;
  cluster_id?: number | string;
  cluster_id__startswith?: string;
  cluster_id_startswith_in_csv?: string[];
  chute_id__in?: number[];
  id__gt?: number;
  ordering?: string;
  plan_date?: string;
  plan_no?: string;
  plan_no__in?: number[];
  sector_code?: string;
  sector_code__in?: string[];
  synced?: boolean;
}

export type TShippingGeo = {
  shipping_item__address__lat: number;
  shipping_item__address__lng: number;
  shipping_item__tracking_number: string;
  shipping_item__status?: string;
  is_scanned: boolean;
};

export type TPlanItem = {
  id: number;
  shipping_item_count: number;
  count_scanned_all: number;
  plan_date: string;
  plan_no: string;
  chute_id: number;
  cluster_id: string;
  synced: boolean;
  manual_checkin: boolean;
  container_alias: [];
  sub_category: string;
  shippingitems: string[];
  plan_status: string;
  count_checkedin: string;
  count_scan_manual: string;
  chute_display: string;
  plan_display: string;
  bunny_color: any;
};

export interface IPlanShortItem extends TPlanItem {
  merge_allowed: boolean;
  has_scanned_item: boolean;
}

export interface IPlanLongItem extends TPlanItem{
  "shippingitems_scanned": string[];
  "shippingitems_geo": TShippingGeo[];
}

export interface IShippingWithCluster extends TShippingGeo {
  cluster_id: string;
  id: number;
}
